module.exports = __webpack_public_path__ + "assets/img/jinan.c2376d03.png";